module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indexDesc"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('indexDesc_title')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tipBar"
  }, [_c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_total_revenue')
    }
  }, [_vm._v(_vm._s(_vm.$t('indexDesc_total_revenue_value'))), _c('br'), _vm._v(_vm._s(_vm.$t('indexDesc_total_revenue_value1')) + "\n    ")]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_available'),
      "value": _vm.$t('indexDesc_available_value')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_take_up_room'),
      "value": _vm.$t('indexDesc_take_up_room_value_normal')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_overnight_rate'),
      "value": _vm.$t('indexDesc_overnight_rate_value')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_night_average'),
      "value": _vm.$t('indexDesc_night_average_value')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "REVPAR",
      "value": _vm.$t('indexDesc_REVPAR_value')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_total_rooms'),
      "value": _vm.$t('indexDesc_total_rooms_value')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_since_room')
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('indexDesc_since_room_value'))), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('indexDesc_since_room_value1')) + "\n    ")]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_free_room')
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('indexDesc_free_room_value'))), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('indexDesc_free_room_value1')) + "\n    ")]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_maintenance_room')
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('indexDesc_maintenance_room_value'))), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('indexDesc_maintenance_room_value1')) + "\n    ")]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_locked_room')
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('indexDesc_locked_room_value'))), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('indexDesc_locked_room_value1')) + "\n    ")]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('index_homeData_notarrRoom'),
      "value": _vm.$t('index_homeData_notarrRoom_value')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('index_homeData_isarrRoom'),
      "value": _vm.$t('index_homeData_isarrRoom_value')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('index_homeData_notdepRoom'),
      "value": _vm.$t('index_homeData_notdepRoom_value')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('index_homeData_isdepRoom'),
      "value": _vm.$t('index_homeData_isdepRoom_value')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "index-desc-notice"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('indexDesc_chart_desc')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4a47c710","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/indexDesc.vue
// module id = 1782
// module chunks = 107